<template>
    <div id="wx_welcome" class="card-container">
        <div class="wx_in" v-if="dataStyle === 'style1'">
            <div class="title">
                <div
                    class="title1 main_center cross_center base_font_size_14 base_font_color_606266"
                >
                    {{ chatName.headTitle }}
                </div>
                <div
                    class="title1 main_center cross_center base_font_size_12 base_font_color_606266"
                    style="transform: scale(0.7);"
                >
                    公司名称
                </div>
                <div class="title2 main_center cross_center base_font_size_12">
                    {{ time }}
                </div>
            </div>
            <div class="cont_wrap">
                <div class="cont_in">
                    <div class="cont">
                        <template v-for="(item, index) in data">
                            <div
                                class="dir_right_nowrap main_top"
                                :key="index"
                                style="margin-bottom: 10px;"
                                v-if="item.isShow"
                            >
                                <div
                                    class="user base_background_color_ff5800 main_center cross_center"
                                >
                                    <a-icon type="user" />
                                </div>
                                <div
                                    class="user_txt base_font_size_12 base_font_color_606266"
                                    v-if="item.type !== 'wxapp'"
                                >
                                    <template v-if="item.type === 'image'">
                                        <img :src="item.info" width="100%" />
                                    </template>
                                    <template v-else-if="item.type === 'link'">
                                        <div
                                            class="link_title base_font_size_14 t_omit base_font_color_606266"
                                        >
                                            {{ item.title }}
                                        </div>
                                        <div class="link_desc main_between cross_top">
                                            <div
                                                class="link_txt t_omit_three base_font_size_12 base_font_color_909399"
                                            >
                                                {{ item.description }}
                                            </div>
                                            <div class="link_img box_grow_0">
                                                <img :src="item.cover" v-if="item.cover" />
                                            </div>
                                        </div>
                                    </template>
                                    <template v-else>
                                        <template v-if="item.info.indexOf('\n') < 0">{{
                                            item.info
                                        }}</template>
                                        <template v-else>
                                            <template v-for="(text, textIndex) in toBr(item.info)">
                                                {{ text }}
                                                <template
                                                    v-if="toBr(item.info).length !== textIndex + 1"
                                                >
                                                    <br />
                                                </template>
                                            </template>
                                        </template>
                                    </template>
                                </div>
                                <div
                                    class="user_txt user_wx base_font_size_12 base_font_color_606266"
                                    v-else
                                >
                                    <div class="wxapp">
                                        <div class="wxapp_in">
                                            <div
                                                class="wx_title base_font_size_12 dir_left_wrap cross_center"
                                            >
                                                <img :src="item.info" />
                                                小程序名称
                                            </div>
                                            <div
                                                class="wx_title base_font_size_14 base_font_color_606266"
                                            >
                                                小程序名称
                                            </div>
                                            <img :src="item.info" width="100%" />
                                        </div>
                                        <div class="wx_foot dir_left_wrap cross_center">
                                            <span
                                                class="base_font_size_12 jhgj_iconfont icon_Smallprogram"
                                                style="margin-right: 5px;"
                                            ></span>
                                            小程序
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </template>
                    </div>
                    <div
                        class="title1 main_center cross_center base_font_size_12"
                        v-if="footInfoShow"
                    >
                        对方为企业微信用户，<span class="base_font_color_ff5800">了解更多</span>
                    </div>
                </div>
            </div>
        </div>
        <div class="wx_in2" v-else-if="dataStyle === 'style2'">
            <div
                class="wx_head main_center cross_center"
                :style="{
                    backgroundImage: 'url(' + style2HeadData.imgBg + ')',
                    backgroundRepeat: 'no-repeat',
                    backgroundSize: 'cover'
                }"
            >
                <a-icon
                    type="picture"
                    class="head_center base_font_color_ff5800"
                    v-if="!style2HeadData.imgBg"
                />
                <div
                    class="head_img base_background_color_ff5800 main_center cross_center"
                    :style="{
                        backgroundImage: 'url(' + style2HeadData.headBg + ')',
                        backgroundRepeat: 'no-repeat',
                        backgroundSize: 'cover'
                    }"
                >
                    <a-icon type="user" v-if="!style2HeadData.headBg" />
                </div>
            </div>
            <div class="wx_body">
                <div class="wx_body_in" v-if="!style2BgSet">
                    <div
                        class="body_title dir_left_wrap cross_center base_font_color_606266 base_font_size_12"
                    >
                        <div class="body_img base_background_color_ff5800 main_center cross_center">
                            <a-icon type="picture" />
                        </div>
                        用户昵称
                    </div>
                    <div class="body_cont">
                        <template v-for="(item, index) in data">
                            <div
                                class="dir_left_nowrap main_top"
                                :key="index"
                                style="margin-bottom: 10px;"
                                v-if="item.isShow"
                            >
                                <div
                                    class="user_txt base_font_size_12 base_font_color_606266"
                                    v-if="item.type !== 'wxapp'"
                                >
                                    <template v-if="item.type === 'image'">
                                        <img :src="item.info" width="100%" />
                                    </template>
                                    <template v-else-if="item.type === 'link'">
                                        {{ item.info }}
                                    </template>
                                    <template v-else-if="item.type === 'file'">
                                        <a-card
                                            hoverable
                                            style="background-color: #000; font-size: 20px;"
                                            class="main_center cross_center base_font_color_ff5800"
                                        >
                                            <template v-if="item.info.indexOf('.mp4') > 0">
                                                <a-icon type="video-camera" />
                                            </template>
                                            <template v-else-if="item.info.indexOf('.mp3') > 0">
                                                <a-icon type="audio" />
                                            </template>
                                            <template v-else>
                                                <a-icon type="file" />
                                            </template>
                                        </a-card>
                                    </template>
                                    <template v-else>
                                        <template v-if="item.info.indexOf('\n') < 0">{{
                                            item.info
                                        }}</template>
                                        <template v-else>
                                            <template v-for="(text, textIndex) in toBr(item.info)">
                                                {{ text }}
                                                <template
                                                    v-if="toBr(item.info).length !== textIndex + 1"
                                                >
                                                    <br />
                                                </template>
                                            </template>
                                        </template>
                                    </template>
                                </div>
                                <div
                                    class="user_txt user_wx base_font_size_12 base_font_color_606266"
                                    v-else
                                >
                                    <div class="wxapp">
                                        <div class="wxapp_in">
                                            <div
                                                class="wx_title base_font_size_12 dir_left_wrap cross_center"
                                            >
                                                <img :src="item.info" />
                                                小程序名称
                                            </div>
                                            <div
                                                class="wx_title base_font_size_14 base_font_color_606266"
                                            >
                                                小程序名称
                                            </div>
                                            <img :src="item.info" width="100%" />
                                        </div>
                                        <div class="wx_foot dir_left_wrap cross_center">
                                            <span
                                                class="base_font_size_12 jhgj_iconfont icon_Smallprogram"
                                                style="margin-right: 5px;"
                                            ></span>
                                            小程序
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </template>
                    </div>
                </div>
            </div>
        </div>
        <div class="wx_in3" v-else-if="dataStyle === 'style3'">
            <div
                class="title title1 main_center cross_center base_font_size_14 base_font_color_606266"
            >
                {{ chatName.headTitle }}
            </div>
            <div class="cont_wrap">
                <div class="cont_in">
                    <div class="list_item list_title">
                        {{ style3Data.name || '活动名称' }}
                    </div>
                    <div class="list_item list_guide">
                        {{ style3Data.guide || '引导语' }}
                    </div>
                    <div class="list_item">
                        <div class="item_wrap">
                            <div class="item_head dir_left_wrap cross_center">
                                <a-avatar
                                    shape="square"
                                    :src="style3Data.logo || '/static/img/group_head.jpg'"
                                />
                                <div
                                    class="base_font_size_14 base_font_color_606266"
                                    style="margin-left: 15px;"
                                >
                                    {{ style3Data.chat.name || '实际群名称' }}
                                </div>
                            </div>
                            <div class="item_body">
                                <div
                                    class="ewm_code cross_center main_center"
                                    :style="
                                        style3Data.chat.qrcode
                                            ? 'background:#fff'
                                            : 'background:#f3f3f3'
                                    "
                                >
                                    <img
                                        :src="style3Data.chat.qrcode"
                                        width="100%"
                                        v-if="style3Data.chat.qrcode"
                                    />
                                    <a-icon type="qrcode" :style="{ fontSize: '24px' }" v-else />
                                </div>
                                <div class="ewm_txt base_font_size_12 base_font_color_909399">
                                    该二维码7天内({{ endTime }}前有效)，重新进入将更新
                                </div>
                            </div>
                        </div>
                        <div
                            class="fix_side base_font_size_12 base_font_color_606266 main_center cross_center"
                            v-if="style3Data.isTip"
                        >
                            无法<br />进群
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="wx_txt base_font_size_12 base_font_color_909399" v-if="footInfoShow">
            {{ chatName.footTitle }}
        </div>
    </div>
</template>

<script>
import dayjs from 'dayjs';
export default {
    props: {
        data: {
            type: Array,
            default: function() {
                return [];
            }
        },
        // 样式(style1: 聊天窗口样式；style2：朋友圈样式)
        dataStyle: {
            type: String,
            default: 'style1'
        },
        // style2相关参数
        style2BgSet: {
            type: Boolean,
            default: false
        },
        style2HeadData: {
            type: Object,
            default: function() {
                return {
                    // 朋友圈背景图
                    imgBg: null,
                    // 朋友圈头像
                    headBg: null
                };
            }
        },
        // style3相关参数
        style3Data: {
            type: Object,
            default: function() {
                return {
                    // 引导语
                    name: '',
                    guide: '',
                    logo: '',
                    isTip: false,
                    chat: {}
                };
            }
        },
        // 对话框底部文案，是否展示
        footInfoShow: {
            type: Boolean,
            default: true
        },
        chatName: {
            type: Object,
            default: function() {
                return {
                    headTitle: '客户A',
                    footTitle: '欢迎语样式'
                };
            }
        }
    },
    watch: {
        data() {
            console.log(this.data);
        }
    },
    data() {
        return {
            timeName: ''
        };
    },
    computed: {
        time() {
            let time = '';
            const timeFormat = dayjs().format('M月D日 A h:mm');
            return (time =
                timeFormat.indexOf('AM') > -1
                    ? _.replace(timeFormat, 'AM', '上午')
                    : _.replace(timeFormat, 'PM', '下午'));
        },
        endTime() {
            return dayjs(this.style3Data.chat.endTime).format('MM月DD日');
        }
    },
    mounted() {},
    watch: {
        data(val, old) {
            console.log('watch组件', val, old);
        }
    },
    methods: {
        dayjs,
        // 回车符转br
        toBr(info) {
            if (info.indexOf('\n') > -1) {
                info = info.split('\n');
            }
            return info;
        }
    }
};
</script>

<style scoped>
/* style1 聊天窗口样式 */
#wx_welcome .wx_in {
    background-color: #fafafa;
    border-radius: 10px;
    /* min-height: 300px; */
    padding: 20px 10px;
    overflow: hidden;
}
#wx_welcome .wx_in .title1 {
    line-height: 0.9;
    transform: scale(0.8);
}
#wx_welcome .wx_in .title2 {
    line-height: 2;
    transform: scale(0.7);
    margin: 5px 0;
}
#wx_welcome .wx_txt {
    line-height: 3;
}
#wx_welcome .wx_in .cont_wrap {
    min-height: 340px;
    max-height: 340px;
    overflow-x: hidden;
    overflow-y: auto;
    width: 110%;
}
#wx_welcome .link_title {
    line-height: 2;
}
#wx_welcome .link_txt {
    line-height: 1.2;
    text-align: justify;
    padding: 0 20px 0 0;
}
#wx_welcome .link_img {
    width: 48px;
    height: 48px;
    background-color: #eee;
    overflow: hidden;
    border-radius: 2px;
}
#wx_welcome .link_img img {
    width: 100%;
    height: 100%;
}
@media (max-width: 1600px) {
    #wx_welcome .wx_in .cont_wrap {
        min-height: 240px;
        max-height: 240px;
    }
}
#wx_welcome .wx_in .cont_in {
    width: 90%;
}
#wx_welcome .user {
    width: 26px;
    height: 26px;
    color: #fff;
    font-size: 20px;
    line-height: 1;
    margin-left: 10px;
    border-radius: 2px;
}
#wx_welcome .user_txt {
    background-color: #fff;
    border-radius: 5px;
    padding: 10px;
    border: 1px solid #fafafa;
    width: 80%;
    position: relative;
    box-shadow: 0 0px 3px rgba(0, 0, 0, 0.1);
    word-break: break-all;
}
#wx_welcome .user_txt::before {
    content: '';
    display: block;
    position: absolute;
    right: -6px;
    border-width: 4px 6px;
    border-right: 0;
    width: 0;
    border-style: solid;
    border-color: transparent;
    border-left-color: #fff;
    top: 10px;
    z-index: 888;
}
#wx_welcome .user_wx {
    padding: 0;
}
#wx_welcome .wxapp .wxapp_in {
    padding: 10px;
    border-bottom: 1px solid #eee;
}
#wx_welcome .wxapp .wx_title {
    line-height: 2;
}
#wx_welcome .wxapp .wx_title img {
    width: 20px;
    height: 20px;
    border-radius: 10px;
    margin-right: 10px;
}
#wx_welcome .wxapp .wx_foot {
    padding: 0 10px;
    line-height: 2;
}
/* style2 朋友圈样式 */
#wx_welcome .wx_in2 {
    background-color: #fafafa;
    border-radius: 10px;
    overflow: hidden;
    border: 1px solid rgb(235, 237, 240);
}
#wx_welcome .wx_in2 .wx_head {
    background-color: #a6d0f7;
    height: 120px;
    position: relative;
    margin-bottom: 37px;
}
#wx_welcome .wx_in2 .head_center {
    font-size: 80px;
    line-height: 1;
}
#wx_welcome .wx_in2 .head_img {
    color: #fff;
    width: 34px;
    height: 34px;
    color: #fff;
    font-size: 16px;
    line-height: 1;
    border-radius: 2px;
    position: absolute;
    right: 10px;
    bottom: -17px;
}
#wx_welcome .wx_in2 .wx_body {
    min-height: 340px;
    max-height: 340px;
    overflow-x: hidden;
    overflow-y: scroll;
    width: 105.5%;
}
@media (max-width: 1600px) {
    #wx_welcome .wx_in2 .wx_body {
        min-height: 220px;
        max-height: 220px;
    }
}
#wx_welcome .wx_in2 .wx_body_in {
    padding: 0 10px 20px 10px;
}
#wx_welcome .wx_in2 .body_title {
    margin-bottom: 15px;
}
#wx_welcome .wx_in2 .body_img {
    color: #fff;
    width: 34px;
    height: 34px;
    color: #fff;
    font-size: 16px;
    line-height: 1;
    margin-right: 10px;
    border-radius: 2px;
}
#wx_welcome .wx_in2 .body_cont {
    padding-left: 44px;
}
#wx_welcome .wx_in2 .user_txt {
    background-color: inherit;
    border-radius: 0;
    padding: 0;
    border: 0 none;
    position: relative;
    box-shadow: 0 0px 0 rgba(0, 0, 0, 0);
}
#wx_welcome .wx_in2 .user_txt::before {
    display: none;
}
#wx_welcome .wx_in2 .wxapp {
    background-color: #fff;
    box-shadow: 0 0 3px rgba(0, 0, 0, 0.1);
    border-radius: 2px;
}
/* style3 */
#wx_welcome .wx_in3 {
    background-color: #fafafa;
    border-radius: 10px;
    padding: 20px 10px;
    overflow: hidden;
}
#wx_welcome .wx_in3 .title1 {
    line-height: 0.9;
    transform: scale(0.8);
}
#wx_welcome .wx_in3 .cont_wrap {
    min-height: 400px;
    max-height: 400px;
    overflow-x: hidden;
    overflow-y: auto;
    width: 100%;
}
#wx_welcome .wx_in3 .cont_wrap::-webkit-scrollbar {
    display: none;
}
#wx_welcome .wx_in3 .cont_in {
    padding: 30px 10px;
}
#wx_welcome .wx_in3 .list_item {
    position: relative;
}
#wx_welcome .wx_in3 .list_title {
    margin-bottom: 5px;
    text-align: center;
    font-weight: bold;
    line-height: 1.4;
}
#wx_welcome .wx_in3 .list_guide {
    margin-bottom: 15px;
    text-align: center;
    font-size: 12px;
    line-height: 1.4;
}
#wx_welcome .wx_in3 .item_wrap {
    border-radius: 10px;
    background-color: #fff;
    padding: 15px;
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);
}
#wx_welcome .wx_in3 .item_body {
    text-align: center;
}
#wx_welcome .wx_in3 .item_body img {
    background: #fff;
    padding: 0 15px;
}
#wx_welcome .wx_in3 .ewm_code {
    width: 100%;
    height: 100%;
    min-height: 160px;
    margin: 15px 0 5px 0;
}
#wx_welcome .wx_in3 .ewm_txt {
    transform: scale(0.8);
}
#wx_welcome .wx_in3 .fix_side {
    width: 50px;
    height: 50px;
    border-radius: 100%;
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.2);
    background-color: #fff;
    position: absolute;
    bottom: 40px;
    right: -15px;
    z-index: 10;
    transform: scale(0.7);
}
@media (max-width: 1600px) {
    #wx_welcome .wx_in3 .cont_wrap {
        min-height: 300px;
        max-height: 300px;
    }
}
</style>
